import { render, staticRenderFns } from "./PageNotFound.vue?vue&type=template&id=73c303d8&"
import script from "./PageNotFound.vue?vue&type=script&lang=js&"
export * from "./PageNotFound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73c303d8')) {
      api.createRecord('73c303d8', component.options)
    } else {
      api.reload('73c303d8', component.options)
    }
    module.hot.accept("./PageNotFound.vue?vue&type=template&id=73c303d8&", function () {
      api.rerender('73c303d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/page/PageNotFound.vue"
export default component.exports